import { render, staticRenderFns } from "./SidebarReduceExpand.vue?vue&type=template&id=29c6a46f"
import script from "./SidebarReduceExpand.vue?vue&type=script&lang=js"
export * from "./SidebarReduceExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports